export enum AiCompletionKnownErrors {
    RateLimitExceededByUser = "RateLimitExceededByUser",
    RateLimitExceededByAccount = "RateLimitExceededByAccount",
}
